module.exports = __webpack_public_path__ + "img/Ekwateur_80X30.077ba01d.png";